import { useEffect, useState } from 'react';

import { VersionReviewDialog } from '../../../components/VersionReviewDialog/index.js';
import { mapServerGrader } from '../../../hooks/useGraders/useGraders.utils.js';
import type { GraderVersion } from '../../../services/grader.interface.js';
import { useStyles } from '../GraderPage.style.js';

import { OverviewTab } from './OverviewTab.js';

export interface GraderVersionSnapshotDialogProps {
  version: GraderVersion | null;
  workspaceName: string;
  onClose: () => void;
}

export function GraderVersionSnapshotDialog({
  version,
  workspaceName,
  onClose,
}: GraderVersionSnapshotDialogProps) {
  const styles = useStyles();
  const [shown, setShown] = useState<GraderVersion | null>(version);
  useEffect(() => {
    if (version !== null) setShown(version);
  }, [version]);

  const grader = shown === null ? null : mapServerGrader(shown);

  return (
    <VersionReviewDialog
      open={version !== null}
      title={
        shown ? `${shown.name} — version ${String(shown.version)}` : 'Version'
      }
      onClose={onClose}
    >
      {grader && (
        <div className={styles.editorBody}>
          <OverviewTab judge={grader} workspaceName={workspaceName} />
        </div>
      )}
    </VersionReviewDialog>
  );
}
